import axios from "axios";
import { getHeadersAPI } from "../api/ServicesConfiguration";

export async function validateGuid(guid:string){
    let isValid:boolean = false;


    try {
        const response: any = await axios.get(process.env.REACT_APP_BASE_API_URL + '/validateGuid/' + guid, {
            headers: await getHeadersAPI()
        });

        if(response) {
            isValid = response.data;
        }       

    } catch (error) {
        isValid = false;
    }

    return isValid
}